import Loadable from '../../components/loadable';

const SyncEzidebitPayersModal = Loadable({
  loader: () => import('../../pages/payers/sync_ezidebit_payers_modal'),
  type: 'modal',
});

angular.module('gym').value('SyncEzidebitPayersModal', SyncEzidebitPayersModal);
